import { Alert, Button, Loader, Modal, Stack, Text } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useEffect, useState } from "react";

interface AddCardModalProps {
  opened: boolean;
  closed(): void;
}

export function AddCardModal(props: AddCardModalProps) {
  const [embedUrl, setEmbedUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchTableItems() {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          window.location.origin + "/server/client_service/cards",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError("There was an error on our end! Please try again later.");
          throw new Error("Failed to fetch items");
        }

        let resData = await response.json();
        console.log("Res data is", resData);
        setEmbedUrl(resData.hostedpage.url);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
        setError("Failed to load card form. Please try again.");
      }
    }
    if (props.opened) {
      fetchTableItems();
    }
  }, [props.opened]);

  return (
    <Modal
      opened={props.opened}
      onClose={props.closed}
      size="xl"
      title="Add Card"
      centered
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      <Stack
        h="60vh"
        bg="var(--mantine-color-body)"
        align="center"
        justify="center"
        gap="md"
      >
        {loading ? (
          <Loader />
        ) : error ? (
          <Alert variant="filled" color="red" title="Error loading card form" icon={<IconAlertCircle />}>
            {error}
          </Alert>
        ) : (
          <iframe height="100%" width="100%" src={embedUrl}></iframe>
        )}
      </Stack>
    </Modal>
  );
}
